import { render } from "./Tipos_dispositivos.vue?vue&type=template&id=23f8e8f8&scoped=true"
import script from "./Tipos_dispositivos.vue?vue&type=script&lang=js"
export * from "./Tipos_dispositivos.vue?vue&type=script&lang=js"

import "./Tipos_dispositivos.vue?vue&type=style&index=0&id=23f8e8f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f8e8f8"]])

export default __exports__